"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.destinationInput = exports.destinationConfigRequest = exports.mysqlConnectorDestinationRequest = exports.bqDestinationUpdateRequestSchema = void 0;
const zod_1 = require("zod");
const ConnectorDestinations = ['bigquery', 'mysql'];
exports.bqDestinationUpdateRequestSchema = zod_1.z.object({
    type: zod_1.z.literal('bigquery'),
    project: zod_1.z.string().min(1),
    dataset: zod_1.z.string().min(1),
    table: zod_1.z.string().min(1),
    location: zod_1.z.string().optional(),
    table_expiration_in_ms: zod_1.z.number().optional(),
});
exports.mysqlConnectorDestinationRequest = zod_1.z.object({
    type: zod_1.z.literal('mysql'),
    schema: zod_1.z.string().min(1),
    table: zod_1.z.string().min(1),
});
exports.destinationConfigRequest = zod_1.z.discriminatedUnion('type', [
    exports.bqDestinationUpdateRequestSchema,
    exports.mysqlConnectorDestinationRequest,
]);
// DESTINATION CONFIGS
const AllDestinationConfigs = ['pk_upsert', 'append'];
exports.destinationInput = zod_1.z.discriminatedUnion('type', [
    zod_1.z.object({
        type: zod_1.z.literal('pk_upsert'),
        pk_column_ids: zod_1.z.string().array().min(1),
    }),
    zod_1.z.object({
        type: zod_1.z.literal('append'),
    }),
]);
